import ModelFactory from '../model-factory';
import { BaseModel } from '../models';

export default class AppPromo extends BaseModel {
  constructor(data = {}) {
    super(data);

    this.ratingAverage = data.AVG_RATING || null;
    this.creationDate = data.CREATION_DATE || null;
    this.modifyDate = data.MODIFY_DATE || null;
    this.templateId = data.DOC_TEMPLATE_ID || null;
    this.hits = data.HITS || null;
    this.summary = data.SUMMARY || null;
    this.resolution = data.RESOLUTION || null;
    this.statusId = data.STATUS_ID || null;
    this.title = data.TITLE || null;
    this.zinfo_usuariofinal = data.ZINFO_USUARIOFINAL || null;

    this.primaryIndex = null;
    if (data.PRIMARY_INDEX != null) {
      this.primaryIndex = data.PRIMARY_INDEX['@COMMON_NAME'] || null;
    }

    this.pGroupId = null;
    if (data.PGROUP_ID != null) {
      this.pGroupId = data.PGROUP_ID.id || null;
    }
  }

  extend(newsItem) {
    this.summary = newsItem.summary;
    this.resolution = newsItem.resolution;
  }
}

export const modelFactory = new ModelFactory('popup ', (data) => new AppPromo(data));
